import { createApi } from "./client";

export type PartOfDay = "ANY" | "MORNING" | "AFTERNOON" | "EVENING";

export function joinWaitlist(
    apiBase: string,
    companySlug: string,
    payload: {
        serviceId: number;
        staffId: number | null;
        date: string;
        partOfDay: PartOfDay;
        customerName: string;
        customerEmail: string;
        customerPhone: string | null;
    }
) {
    const api = createApi(apiBase);
    return api<void>(`/api/companies/${companySlug}/waitlist`, {
        method: "POST",
        body: payload,
    });
}
